import { HasAccountModalView } from "./has-account-modal-view";
import type { Properties } from "./properties";

export const HasAccountModal = (props: Properties) => (
	<HasAccountModalView {...props} />
);
